import "./supplychain.css";


import Navbar from "../components/Navbar.js";


import Footer from "../components/Footer.js";

const Predictive = () => {

  return (
    <div>
      <Navbar />
      <div className="spacer"></div>
      {/* Predictive Maintenance Section */}

      <div className="supply-container">
        <div className="supply-header">
          <h1 className="supply-title">
            No Surprises.
            <br />
            Just Smooth Running.
          </h1>
          <p className="supply-description">
            Machines don’t just stop working—they show signs first. But spotting
            those signs? Not always easy. That’s where we come in. Our smart AI
            and real-time data keep a constant eye on your equipment. We catch
            the early warning signs, help you plan fixes in advance, and stop
            problems before they happen. That means fewer surprises, lower
            costs, and machines that last longer.
          </p>
        </div>
      </div>

      <div className="containerSupply">
        <div className="image-sectionSupply">
          <img src="predictive1.png" alt="Product Line" />
        </div>
        <div className="contentSupply">
          <h1>
            CUT MACHINE DOWNTIME BY 50% WITH PREDICTIVE
            <br /> MAINTENANCE
          </h1>
          <hr style={{ maxWidth: "100%" }}></hr>
          <h4 style={{ fontWeight: "300" }}>
            Implement strategies for continuous operation and minimizing
            unexpected failures and save <br class="responsive-br" />
            thousands in downtime costs.
          </h4>
          <ul className="featuresSupply">
            <li>Catching issues early, preventing halts.</li>
            <li>Save thousands in downtime costs.</li>
          </ul>
        </div>
      </div>

      <div className="container">
        <div className="content">
          <h1>
            BOOST WORKPLACE SAFETY BY 70% WITH EARLY <br />
            DETECTION
          </h1>
          <hr style={{ maxWidth: "100%" }}></hr>
          <h4 style={{ fontWeight: "300" }}>
            Identify equipment issues early to prevent failures and enhance
            safety.
          </h4>
          <ul className="features">
            <li>Zero Accident, Zero Penalty Fines</li>
            <li>Prevent Near Misses effectively</li>
          </ul>
        </div>
        <div className="image-section">
          <img src="predictive2.png" alt="Product Line" />
        </div>
      </div>

      <div className="containerSupply">
        <div className="image-sectionSupply">
          <img src="predictive3.png" alt="Product Line" />
        </div>
        <div className="contentSupply">
          <h1>ENHANCE ASSEST LONGEVITY BY 40%</h1>
          <h4 style={{ fontWeight: "300" }}>
            <hr style={{ maxWidth: "100%" }}></hr>
            Boost lifespan of equipment by 20-40% through timely maintenance.
          </h4>
          <ul className="featuresSupply">
            <li>Avoid Unnecessary Capital Investment</li>
            <li>Maintain Ideal Operating Condition</li>
          </ul>
        </div>
      </div>
<div>
</div>
      <Footer />
    </div>
  );
};

export default Predictive;
